import { Dispatch } from 'react'
import { Typography } from '@material-ui/core';
import { FormikForApp } from 'components/FormikField';
import { BusinessUnitSearchBar } from 'ApprovalGroupsPage/components';
import { useMyProfileQuery } from 'MyProfile/query/myProfile.query';
import { ReactComponent as NotFoundSvg } from '../../../components/QueryErrorResetBoundary/svg/NotFound.svg';

import * as Model from './model'

type QueryModel = Model.FindQuery

export default function SearchForm(p: {
  defaultQuery: QueryModel
  onQuery: Dispatch<QueryModel>
}) {

  const { data: userData } = useMyProfileQuery();
  const isAdmin = userData?.isAdmin;
  const allowedDivisionCodes = !userData?.isAdmin && userData?.roles
    ? userData?.roles
      .filter(r => r.type === 'LocalAdministrator')
      .flatMap(r => r.details?.map(d => d.description1))
      .filter(Boolean)
    : [];

  return (
    <FormikForApp validate={p.onQuery} initialValues={p.defaultQuery} onSubmit={p.onQuery}>
      {(p) => <>
        <BusinessUnitSearchBar onBuChange={(value) => p.setFieldValue("division", value)} allowedDivisionCodes={allowedDivisionCodes} isAdmin={isAdmin} />
        { !p.values.division &&
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
            <NotFoundSvg />
            <Typography variant="h6">
              Select Division first...
            </Typography>
          </div>
        }
      </>}
    </FormikForApp>)
}